export default "__VITE_ASSET__BX67jXzk__"